import { StateForm } from "src/app/services/response-models/form.response.model";

export class LoadStateFormTemplate {
    public static readonly type = "[Form Templates] Load state form template";

    constructor(public payload: StateForm) {}
}
